import { render, staticRenderFns } from "./PaseMedicoFiles.vue?vue&type=template&id=0b0059db&scoped=true"
import script from "./PaseMedicoFiles.vue?vue&type=script&lang=js"
export * from "./PaseMedicoFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0059db",
  null
  
)

export default component.exports